import React from 'react';
import styles from './AdshelClassic.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const adshelImg = require('../../../../images/Illustration_Play_Adshel.png');
const adshelCanNotLoadImg = require('../../../../images/adshel_can_not_load_adcopy.png');

const Adshel = ({ mediaArray, videoAutoPlayInterval }) => {

    return (
        <BasePanel
            mediaArray={mediaArray}
            backgroundImage={adshelImg}
            cannotLoadImage={adshelCanNotLoadImg}
            customStyles={styles}
            videoAutoPlayInterval={videoAutoPlayInterval}
        />
    );
};

export default Adshel;